export default "__VITE_ASSET__CJkDKpfJ__"